<app-summary *ngIf="partnerSummary">
    <ng-container title>
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAgCAIAAACdAM/hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACGSURBVEhL7dJBDoMgEAVQuqg9hIOm9qCsSrguXAB/pt8IqStN1AUvJjLz+RujyVtSSqaAkUGtlReHyjFG9hRGBrXtMrCnuPpj3tOnBxE+vdgBRvaU1ZVYi3S9KYLo8buxx7N78XQ27/23FkJwzjFWGLFkXDj2tfmuXfeHtXIrF1p5cfNyzjMg3iHoTr4eOQAAAABJRU5ErkJggg=="
                 style="max-height: 14px; margin-right: 3px;" *ngIf="partnerSummary.dead"/>
        <strong *ngIf="strongLabel">
            {{formattedPartnerName}}</strong>
        <span *ngIf="!strongLabel">{{formattedPartnerName}}</span>
    </ng-container>
    <ng-container content>
        <app-summary-field *ngIf="displayPartnerType" [value]="partnerSummary.mainType.type.label"></app-summary-field>
        <app-datetime-summary-field label="Date de création" [datetime]="partnerSummary.createdAt" *ngIf="displayCreationDate && partnerSummary.createdAt"></app-datetime-summary-field>
        <app-user-summary-field label="Créé par" [entity]="partnerSummary.createdBy" *ngIf="displayCreator && partnerSummary.createdBy"></app-user-summary-field>
        <app-partner-similar-partner-summary-field [partnerSummary]="partnerSummary"></app-partner-similar-partner-summary-field>
        <app-summary-field *ngIf="displayId" [value]="'#' + partnerSummary.id"></app-summary-field>
        <app-summary-field *ngIf="partnerSummary.businessNumber"
                           [value]="partnerSummary.businessNumber"></app-summary-field>
        <app-additional-property-label *ngFor="let prop of partnerSummary.additionalProperties"
                                       [additionalProperty]="prop" [showLabel]="false"
                                       [iconName]="prop.key === 'BIRTHDATE' ? 'cake' : undefined">
        <ng-container *ngIf="prop.key === 'BIRTHDATE'">
            &nbsp;(<strong><app-age-label [date]="prop.value"></app-age-label></strong>)
        </ng-container>
        </app-additional-property-label>
        <app-comment-summary-field [comment]="partnerSummary.note" *ngIf="partnerSummary.note"></app-comment-summary-field>

        <app-summary-field *ngIf="partnerSummary.email" iconName="mail">
            <email [email]="partnerSummary.email"></email>
        </app-summary-field>
        <app-summary-field *ngIf="partnerSummary.phone" iconName="phone">
            <app-phone-label [phone]="partnerSummary.phone"></app-phone-label>
        </app-summary-field>
        <app-summary-field *ngIf="partnerSummary.mobilePhone" iconName="phone">
            <app-phone-label [phone]="partnerSummary.mobilePhone"></app-phone-label>
        </app-summary-field>
        <app-summary-field *ngIf="partnerSummary.officePhone" iconName="phone">
            <app-phone-label [phone]="partnerSummary.officePhone"></app-phone-label>
        </app-summary-field>
        <app-summary-field [value]="address" iconName="map-pin" *ngFor="let address of partnerSummary.addresses"></app-summary-field>

    </ng-container>
    <ng-container badges *ngIf="displayTags && tagEntityType">
        <app-tags-summary-field [entityId]="partnerSummary.id" [entityType]="tagEntityType"></app-tags-summary-field>
    </ng-container>
</app-summary>
